var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ad" },
    [
      _c("h2", [_vm._v("广告")]),
      _vm._v(" "),
      _c("div", { staticClass: "normal" }, [
        _vm._v("\n    广告名称：\n    "),
        _c(
          "div",
          { staticClass: "inputBox" },
          [
            _c("el-input", {
              model: {
                value: _vm.ad_name,
                callback: function($$v) {
                  _vm.ad_name = $$v
                },
                expression: "ad_name"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "normal" },
        [
          _vm._v("\n    广告跳转：\n    "),
          _c(
            "el-radio",
            {
              attrs: { label: "楼盘页面" },
              model: {
                value: _vm.goto,
                callback: function($$v) {
                  _vm.goto = $$v
                },
                expression: "goto"
              }
            },
            [_vm._v("楼盘页面")]
          ),
          _vm._v(" "),
          _c(
            "el-radio",
            {
              attrs: { label: "文章页面" },
              model: {
                value: _vm.goto,
                callback: function($$v) {
                  _vm.goto = $$v
                },
                expression: "goto"
              }
            },
            [_vm._v("文章页面")]
          ),
          _vm._v(" "),
          _c(
            "el-radio",
            {
              attrs: { label: "销售个人" },
              model: {
                value: _vm.goto,
                callback: function($$v) {
                  _vm.goto = $$v
                },
                expression: "goto"
              }
            },
            [_vm._v("销售个人")]
          ),
          _vm._v(" "),
          _c(
            "el-radio",
            {
              attrs: { label: "小程序" },
              model: {
                value: _vm.goto,
                callback: function($$v) {
                  _vm.goto = $$v
                },
                expression: "goto"
              }
            },
            [_vm._v("小程序")]
          ),
          _vm._v(" "),
          _c(
            "el-radio",
            {
              attrs: { label: "品牌馆" },
              model: {
                value: _vm.goto,
                callback: function($$v) {
                  _vm.goto = $$v
                },
                expression: "goto"
              }
            },
            [_vm._v("品牌馆")]
          ),
          _vm._v(" "),
          _c(
            "el-radio",
            {
              attrs: { label: "合集" },
              model: {
                value: _vm.goto,
                callback: function($$v) {
                  _vm.goto = $$v
                },
                expression: "goto"
              }
            },
            [_vm._v("合集")]
          ),
          _vm._v(" "),
          _c(
            "el-radio",
            {
              attrs: { label: "装修活动" },
              model: {
                value: _vm.goto,
                callback: function($$v) {
                  _vm.goto = $$v
                },
                expression: "goto"
              }
            },
            [_vm._v("装修活动")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.goto === "楼盘页面"
        ? _c(
            "div",
            { staticClass: "normal" },
            [
              _vm._v("\n    广告楼盘：\n    "),
              _c(
                "el-select",
                {
                  ref: "adSelect2",
                  attrs: {
                    filterable: "",
                    placeholder: "选择楼盘",
                    "default-first-option": "",
                    "remote-method": _vm.searchEstate,
                    remote: "",
                    clearable: ""
                  },
                  on: {
                    "hook:mounted": _vm.cancalReadOnly,
                    "visible-change": _vm.cancalReadOnly
                  },
                  model: {
                    value: _vm.toRealPage,
                    callback: function($$v) {
                      _vm.toRealPage = $$v
                    },
                    expression: "toRealPage"
                  }
                },
                _vm._l(_vm.matchEstates, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.real_estate_name, value: item.id }
                  })
                }),
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.goto === "销售个人"
        ? _c(
            "div",
            { staticClass: "normal" },
            [
              _vm._v("\n    跳转销售：\n    "),
              _c(
                "el-select",
                {
                  ref: "adSelect3",
                  attrs: {
                    filterable: "",
                    placeholder: "搜索姓名",
                    "default-first-option": "",
                    "remote-method": _vm.chooseSale,
                    remote: ""
                  },
                  on: {
                    "hook:mounted": _vm.cancalReadOnly,
                    "visible-change": _vm.cancalReadOnly
                  },
                  model: {
                    value: _vm.sale_id,
                    callback: function($$v) {
                      _vm.sale_id = $$v
                    },
                    expression: "sale_id"
                  }
                },
                _vm._l(_vm.saleList, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: {
                      label: item.user_name + "(" + item.user_type + ")",
                      value: item.id
                    }
                  })
                }),
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.goto === "装修活动"
        ? _c(
            "div",
            { staticClass: "normal" },
            [
              _vm._v("\n    活动品牌商：\n    "),
              _c(
                "el-select",
                {
                  ref: "adSelect7",
                  attrs: {
                    filterable: "",
                    placeholder: "搜索品牌名",
                    "default-first-option": "",
                    "remote-method": _vm.choosePinpai,
                    remote: ""
                  },
                  on: {
                    "hook:mounted": _vm.cancalReadOnly,
                    "visible-change": _vm.cancalReadOnly
                  },
                  model: {
                    value: _vm.pinpai_id,
                    callback: function($$v) {
                      _vm.pinpai_id = $$v
                    },
                    expression: "pinpai_id"
                  }
                },
                _vm._l(_vm.pinpaiList, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.name, value: item.id }
                  })
                }),
                1
              ),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  ref: "adSelect8",
                  attrs: {
                    filterable: "",
                    placeholder: "搜索活动名",
                    "default-first-option": "",
                    "remote-method": _vm.chooseAct,
                    remote: ""
                  },
                  on: {
                    "hook:mounted": _vm.cancalReadOnly,
                    "visible-change": _vm.cancalReadOnly
                  },
                  model: {
                    value: _vm.act_id,
                    callback: function($$v) {
                      _vm.act_id = $$v
                    },
                    expression: "act_id"
                  }
                },
                _vm._l(_vm.activityList, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.title, value: item.id }
                  })
                }),
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.goto === "文章页面"
        ? _c("div", { staticClass: "normal" }, [
            _c("div", { staticClass: "normal" }, [
              _vm._v("\n      跳转文章：\n      "),
              _c(
                "div",
                { staticClass: "inputBox" },
                [
                  _c("el-input", {
                    model: {
                      value: _vm.toArtical,
                      callback: function($$v) {
                        _vm.toArtical = $$v
                      },
                      expression: "toArtical"
                    }
                  })
                ],
                1
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.isAdmin && ["开屏广告", "首页顶部"].includes(_vm.type)
        ? _c("div", { staticClass: "normal" }, [
            _vm._v("\n    目标曝光量：\n    "),
            _c(
              "div",
              { staticClass: "inputBox" },
              [
                _c("el-input", {
                  attrs: { type: "number" },
                  model: {
                    value: _vm.goal,
                    callback: function($$v) {
                      _vm.goal = $$v
                    },
                    expression: "goal"
                  }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "normal" },
        [
          _vm._v("\n    广告位置：\n    "),
          _c(
            "el-select",
            {
              ref: "adSelect4",
              attrs: { placeholder: "请选择" },
              on: {
                "hook:mounted": _vm.cancalReadOnly,
                "visible-change": _vm.cancalReadOnly
              },
              model: {
                value: _vm.type,
                callback: function($$v) {
                  _vm.type = $$v
                },
                expression: "type"
              }
            },
            _vm._l(_vm.types, function(item) {
              return _c("el-option", {
                key: item,
                attrs: { label: item, value: item }
              })
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.goto === "楼盘组团" || _vm.type === "上竞品的楼盘页"
        ? _c(
            "div",
            { staticClass: "normal" },
            [
              _vm.type === "上竞品的楼盘页"
                ? _c("span", [_vm._v("竞品楼盘：")])
                : _c("span", [_vm._v("楼盘组团：")]),
              _vm._v(" "),
              _vm._l(_vm.estates, function(estate, index) {
                return _c("div", { key: estate.id }, [
                  _c("span", [_vm._v(_vm._s(estate.real_estate_name))]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      on: {
                        click: function($event) {
                          return _vm.estates.splice(index, 1)
                        }
                      }
                    },
                    [_vm._v("删除")]
                  )
                ])
              }),
              _vm._v(" "),
              _c(
                "el-select",
                {
                  ref: "adSelect1",
                  attrs: {
                    filterable: "",
                    placeholder: "选择楼盘",
                    "default-first-option": "",
                    "remote-method": _vm.searchEstate,
                    remote: "",
                    clearable: ""
                  },
                  on: {
                    "hook:mounted": _vm.cancalReadOnly,
                    "visible-change": _vm.cancalReadOnly,
                    change: _vm.addEstate
                  },
                  model: {
                    value: _vm.chooseId,
                    callback: function($$v) {
                      _vm.chooseId = $$v
                    },
                    expression: "chooseId"
                  }
                },
                _vm._l(_vm.matchEstates, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.real_estate_name, value: item.id }
                  })
                }),
                1
              )
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.goto === "品牌馆"
        ? _c(
            "div",
            { staticClass: "normal" },
            [
              _c(
                "el-select",
                {
                  ref: "adSelect5",
                  attrs: {
                    filterable: "",
                    placeholder: "选择品牌馆",
                    "default-first-option": "",
                    "remote-method": _vm.searchBrand,
                    remote: "",
                    clearable: ""
                  },
                  on: {
                    "hook:mounted": _vm.cancalReadOnly,
                    "visible-change": _vm.cancalReadOnly
                  },
                  model: {
                    value: _vm.brand_id,
                    callback: function($$v) {
                      _vm.brand_id = $$v
                    },
                    expression: "brand_id"
                  }
                },
                _vm._l(_vm.brandList, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.name, value: item.id }
                  })
                }),
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.goto === "合集"
        ? _c(
            "div",
            { staticClass: "normal" },
            [
              _c(
                "el-select",
                {
                  ref: "adSelect6",
                  attrs: {
                    filterable: "",
                    placeholder: "选择合集",
                    "default-first-option": "",
                    "remote-method": _vm.searchCollect,
                    remote: "",
                    clearable: ""
                  },
                  on: {
                    "hook:mounted": _vm.cancalReadOnly,
                    "visible-change": _vm.cancalReadOnly
                  },
                  model: {
                    value: _vm.collect_id,
                    callback: function($$v) {
                      _vm.collect_id = $$v
                    },
                    expression: "collect_id"
                  }
                },
                _vm._l(_vm.collectList, function(item) {
                  return _c("el-option", {
                    key: item.id,
                    attrs: { label: item.name, value: item.id }
                  })
                }),
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.noImage.includes(_vm.type)
        ? _c("div", { staticClass: "normal" }, [
            _vm._v("\n    广告图片\n    "),
            _c("div", { staticClass: "normal" }, [
              _c("input", {
                attrs: { id: "ad", type: "file" },
                on: { change: _vm.chooseImageCompress }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "normal" }, [
              _c("img", {
                staticClass: "adImg",
                attrs: {
                  src: _vm.adImgUrl,
                  alt: "",
                  preview: "6",
                  "preview-text": "广告图"
                }
              })
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.type === "亚运活动"
        ? _c(
            "div",
            { staticClass: "radio-group" },
            [
              _vm._v("\n    展位权重：\n    "),
              _c(
                "el-radio-group",
                {
                  model: {
                    value: _vm.weight,
                    callback: function($$v) {
                      _vm.weight = $$v
                    },
                    expression: "weight"
                  }
                },
                [
                  _c("el-radio", { attrs: { label: 4.3 } }, [
                    _vm._v("一档(4)")
                  ]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: 2 } }, [_vm._v("二档(2)")]),
                  _vm._v(" "),
                  _c("el-radio", { attrs: { label: 1 } }, [_vm._v("三档(1)")])
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.goto === "楼盘组团"
        ? _c("div", { staticClass: "normal" }, [
            _vm._v("\n    组团海报\n    "),
            _c("div", { staticClass: "normal" }, [
              _c("input", {
                attrs: { id: "group", type: "file" },
                on: { change: _vm.chooseImage }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "normal" }, [
              _c("img", {
                staticClass: "groupImg",
                attrs: {
                  src: _vm.groupImgUrl,
                  alt: "",
                  preview: "6",
                  "preview-text": "广告图"
                }
              })
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-select",
        {
          attrs: {
            filterable: "",
            placeholder: "选择上传版本",
            "default-first-option": ""
          },
          model: {
            value: _vm.status,
            callback: function($$v) {
              _vm.status = $$v
            },
            expression: "status"
          }
        },
        _vm._l(_vm.statuslist, function(item) {
          return _c("el-option", {
            key: item,
            attrs: { label: item, value: item }
          })
        }),
        1
      ),
      _vm._v(" "),
      _c("el-date-picker", {
        attrs: {
          type: "datetimerange",
          "value-format": "yyyy-MM-dd HH:mm:ss",
          "range-separator": "至",
          "start-placeholder": "开始日期",
          "end-placeholder": "结束日期",
          "default-time": ["00:00:00", "23:59:59"]
        },
        model: {
          value: _vm.date_range,
          callback: function($$v) {
            _vm.date_range = $$v
          },
          expression: "date_range"
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "normal" },
        [
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.upToDb } },
            [_vm._v("上传")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0a7ef25a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0a7ef25a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/ad.vue
// module id = null
// module chunks = 